import { styled } from '@mui/material';

export const Map = styled('div')`
  height: 90%;
  width: auto;
  border-radius: 15px;
  overflow: hidden;
  body {
    background-color: 'black';
  }
  svg {
    fill: #363cff;
    text {
      fill: #fff !important;
      font-weight: 800;
    }
  }
`;
